import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import { SCROLL_CONTENT_CLASS_NAME } from '../../constants/common'
import { EVENT_NAME_SCROLL } from '../../constants/event'
import { useEventListener } from '../../hooks'
import { toCSSPixel } from '../../utils/styles'
import { LoaderListItem } from '../ListItem'

import { Extra } from './Extra'
import { LIST_MAX_HEIGHT } from './List.constants'

import * as styles from './List.module.css'

function List({
  ExtraItem,
  children,
  className,
  extraItemProps,
  isLoading,
  itemsWrapperClassName,
  maxHeight = LIST_MAX_HEIGHT,
  prependItem,
  searchElement,
  setListHeight,
  wrapperRef: outerWrapperRef,
  onScroll,
}) {
  const [isScrollable, setScrollable] = useState(false)

  const wrapperRef = useRef(null)
  const listRef = useRef(null)

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (listRef.current && setListHeight) {
        setListHeight(listRef.current.getBoundingClientRect().height)
      }
    })

    ro.observe(listRef.current)

    return () => {
      ro.disconnect()
    }
  }, [])

  useEventListener({
    elementRef: wrapperRef,
    eventName: EVENT_NAME_SCROLL,
    handler: onScroll,
  })

  useEffect(() => {
    if (wrapperRef.current && maxHeight) {
      setScrollable(wrapperRef.current.scrollHeight > maxHeight)
    }
  }, [maxHeight, wrapperRef])

  function handleSetWrapperRef(node) {
    wrapperRef.current = node

    if (outerWrapperRef) {
      outerWrapperRef.current = node
    }
  }

  const listClassName = classNames(styles.List, className)

  const wrapperClassName = classNames(
    SCROLL_CONTENT_CLASS_NAME,
    styles.wrapper,
    {
      [styles.scrollable]: isScrollable,
    },
    itemsWrapperClassName
  )

  return (
    <ul className={listClassName} ref={listRef} onScroll={onScroll}>
      {searchElement}
      {prependItem}
      <div
        className={wrapperClassName}
        ref={handleSetWrapperRef}
        style={{
          '--list-wrapper-max-height-base': toCSSPixel(maxHeight),
        }}
      >
        {children}
        {isLoading ? (
          <LoaderListItem hasText className={styles.loader} />
        ) : null}
      </div>
      {!isLoading && ExtraItem ? (
        <Extra {...extraItemProps} Component={ExtraItem} />
      ) : null}
    </ul>
  )
}

export default List
